// src/features/auth/auth.slice.ts
// Auth Redux slice - pure in-memory state, no tokens or cookie access.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { AuthState, SuperAdminUser } from './auth.types'

const initialState: AuthState = {
  user:            null,
  isAuthenticated: false,
  isInitializing:  true, // true on every fresh load - AppInitializer resolves it
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    /**
     * Called after a successful /auth/login or /auth/me response.
     * Fills the store with the authenticated user.
     */
    setUser: (state, action: PayloadAction<SuperAdminUser>) => {
      state.user            = action.payload
      state.isAuthenticated = true
      state.isInitializing  = false
    },

    /**
     * Called on logout or on any 401 response.
     * Wipes the in-memory user - the server clears the httpOnly cookie.
     */
    clearUser: (state) => {
      state.user            = null
      state.isAuthenticated = false
      state.isInitializing  = false
    },

    /**
     * Controls the initializing spinner shown by AuthGuard.
     * Set to true before the /auth/me check, false when it resolves.
     */
    setInitializing: (state, action: PayloadAction<boolean>) => {
      state.isInitializing = action.payload
    },
  },
})

export const { setUser, clearUser, setInitializing } = authSlice.actions
export default authSlice.reducer
